
const capitalizeFirst = lower =>
  lower.replace(/^\w/, function(c) {
    return c.toUpperCase();
  });

export default capitalizeFirst;
  